import Purl from "../helpers/purlMapping";
import { BaseService } from "./base.service";
export class PurlService extends BaseService {
  static async getPurl(purlId = "") {
    try {
      const response = await this.request().post(
        `${process.env.VUE_APP_API_USERS_PATH}`,
        {
          action: "getUserByPurl",
          prefix: process.env.VUE_APP_API_DB_PREFIX,
          purl: purlId,
          timestamp: new Date(),
        }
      );
      if (response?.data?.output?.length === 0) {
        throw new Error("No purl found with provided information");
      } else {
        return new Purl(response?.data?.output);
      }
    } catch (e) {
      throw new Error("Server error: please try again later.");
    }
  }
}
